export const cashPaymentOption = {label: 'Cash', value: 'cash'};

export enum InsuranceStatus {
  Insured = 'insured',
  Uninsured = 'uninsured',
}
